/* istanbul ignore file */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Map as EPMap, withMap, Polyline } from 'commons/js/components/Map'
import mapOptions from './mapOptions'
import { getBounds } from './mapFunctions'
import { themeColor } from '@elparking/components'

const filterSelected = (hightways, active) =>
    hightways.filter(({ selected }) => active === selected)

const fitBounds = (map, highways) => {
    if (!map) {
        return
    }
    const hightwaysForBounds = filterSelected(highways, true)
    map.fitBounds(getBounds(hightwaysForBounds.length
        ? hightwaysForBounds
        : highways
    ))
}

const Map = ({ highways, theme }) => {
    const [ map, setMap ] = useState(null)
    useEffect(() => {
        if (map) {
            fitBounds(map, highways)
        }
    }, [ highways, map ])
    return (
        <div>
            <EPMap
              ref={(map) => { setMap(map) }}
              options={mapOptions}
            >
                {filterSelected(highways, true).map((highway, key) =>
                    <Polyline
                      options={{
                        strokeColor: themeColor('main')({ theme }),
                        strokeWeight: 8,
                      }}
                      key={key}
                      path={highway.path} />
                )}
                {highways.map((highway, key) =>
                    <Polyline
                      options={{
                        strokeColor: themeColor('main60')({ theme }),
                        strokeWeight: 2,
                      }}
                      key={`selected_${key}`}
                      path={highway.path} />
                )}
            </EPMap>
        </div>
    )
}

Map.propTypes = {
    highways: PropTypes.arrayOf(
            PropTypes.shape({
            id: PropTypes.number,
            location: PropTypes.string,
            name: PropTypes.string,
            type: PropTypes.number,
            url: PropTypes.string,
            description: PropTypes.string,
            path: PropTypes.arrayOf(PropTypes.shape({
                lat: PropTypes.number,
                lng: PropTypes.number,
            })),
        })
    ).isRequired,
    theme: PropTypes.any,
}

Map.defaultProps = {
    highways: [],
}

export { Map }

export default withMap(props => <Map {...props} />)
